import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  selector: 'aux-exchange-link',
  template: `
    @if (showExchangePageLink()) {
      <a class="btn--hyperlink exchange-link" [routerLink]="[exchangeCurrencyPage]">
        Exchange Rates
      </a>
    }
  `,
})
export class ExchangeLinkComponent {
  launchDarklyService = inject(LaunchDarklyService);

  exchangeCurrencyPage = `/${ROUTING_PATH.SETTINGS.INDEX}/${ROUTING_PATH.SETTINGS.EXCHANGE_RATES}`;
  showExchangePageLink = this.launchDarklyService.$select((flags) => flags.tab_exchange_rates);
}
